import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Radio, Button, Row, Col } from 'antd';

class FormFilterRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formFilterRadio: {
        input: '1',
      },
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    if (prevState.formFilterRadio.input === '1' && prevProps.options[0].value) {
      return {
        formFilterRadio: {
          input: prevProps.options[0].value,
        },
      };
    }
    return null;
  }

  onChange = e => {
    const formFilterRadio = {
      input: e.target.value,
    };
    this.setState({ formFilterRadio });
  };

  onSubmit = () => {
    this.props.onSubmit(
      this.props.type,
      this.state.formFilterRadio,
      this.props.flagType,
    );
  };

  onCancel = () => {
    this.props.cancelFunction(this.props.type, this.props.flagType);
  };

  _renderForm = () => {
    const { options } = this.props;
    return (
      <Form onSubmit={this.onSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              <Radio.Group
                onChange={this.onChange}
                value={this.state.formFilterRadio.input}
              >
                {options.map(item => (
                  <Radio
                    key={item.value}
                    value={item.value}
                    className="radio-style"
                  >
                    {item.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <div className="row-submit">
            <Button className="btn cancel-btn" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="btn">
              Submit
            </Button>
          </div>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormFilterRadio.propTypes = {
  options: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  flagType: PropTypes.string.isRequired,
};

export default FormFilterRadio;
